import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import Phase from './Phase';
import ModalDeletePhase from '../Modal-Delete-Phase';
import { TabPaneStyles } from '../Tab-Pane-Media/styles';

const TabPanePhases = ({ setStatus, columns, setColumns, kanbanName }) => {
  const { t: translate } = useTranslation();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [selectedPhase, setSelectedPhase] = useState(null);

  const toggleModal = () => {
    const willClose = isOpenModalDelete;
    setIsOpenModalDelete(!isOpenModalDelete);

    if (willClose) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <TabPaneStyles>
      <span>{translate('Kanban Phases')}</span>
      <div className="d-flex flex-column gap-2">
        {columns &&
          columns
            .sort((a, b) => a.position - b.position)
            .map((phase, index) => (
              <Phase
                key={phase.id}
                id={phase.id}
                name={phase.title}
                description={phase.description}
                setColumns={setColumns}
                index={index}
                total={columns.length}
                accountParam={accountParam}
                isNew={phase.isNew}
                setSelectedPhase={setSelectedPhase}
                setIsOpenModalDelete={setIsOpenModalDelete}
                setStatus={setStatus}
              />
            ))}
        <Button
          color="outline"
          style={{ width: '37.5rem' }}
          onClick={() =>
            setColumns([
              ...columns,
              { id: `temp-${columns.length + 1}`, name: '', description: '', isNew: true },
            ])
          }
        >
          <i className="bx bx-plus" />
          {translate('Add phase')}
        </Button>
      </div>
      <ModalDeletePhase
        isOpen={isOpenModalDelete}
        toggle={toggleModal}
        phase={selectedPhase}
        setColumns={setColumns}
        columns={columns}
        setStatus={setStatus}
        kanbanName={kanbanName}
      />
    </TabPaneStyles>
  );
};

TabPanePhases.propTypes = {
  setStatus: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
  setColumns: PropTypes.func.isRequired,
  kanbanName: PropTypes.string.isRequired,
};

export default TabPanePhases;
